import { z } from "zod";
/** Super Admin creates a learner; the system issues an invitation. */
export const createLearnerSchema = z.object({
    email: z.string().trim().toLowerCase().email().max(320),
    displayName: z.string().trim().min(1).max(200),
    organisationId: z.string().min(1),
});
/** Learner accepts an invitation after signing in with Entra. The Entra
 *  identity is taken from the authenticated principal, never the body. */
export const acceptInvitationParamsSchema = z.object({
    token: z.string().min(10).max(200),
});
export const assignProgrammeSchema = z.object({
    learnerId: z.string().min(1),
    programmeId: z.string().min(1),
});
//# sourceMappingURL=invitations.js.map